import React from 'react';

export const AddItemButton = (props) => {
  return (
    <div className="add-item-container" onClick={props.onClick}>
      <span className="add-item-text">{props.buttonText}</span>
    </div>
  );
};
